import { useState } from "react";
import { useThemeContext } from "../../../../Context/ThemeContext";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { getDarkDropdown } from "../../../../Utils/otherFunctions";
import { Link } from "react-router-dom";
import DeleteCapaianSS from "../components/DeleteCapaianSS";
import ModalDetailCapaianSS from "../components/ModalDetailCapaianSS";
import HighlightedCell from "../components/HighlightedCell";

const DaftarCapaianSSColumns = (capaianSS, axiosInstance, filterText) => {
  const [detailOpen, setDetailOpen] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(null);

  const { themeContext } = useThemeContext();

  const [selectedCapaian, setSelectedCapaian] = useState([]);

  const toggleDetailOpen = (row) => {
    setDetailOpen(detailOpen === row.id ? null : row.id);
    if (detailOpen !== row.id) {
      setSelectedCapaian(row);
    } else {
      setSelectedCapaian([]);
    }
  };

  const toggleDeleteOpen = (row) => {
    setDeleteOpen(deleteOpen === row.id ? null : row.id);
    if (detailOpen !== row.id) {
      setSelectedCapaian(row);
    } else {
      setSelectedCapaian([]);
    }
  };

  const columns = [
    {
      name: <DataTableTitle text={"Entitas"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.entitas.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.entitas}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Perspektif"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.perspektif.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.perspektif}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Kode SS"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.kode_ss.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.kode_ss}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Nama SS"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.nama_ss.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.nama_ss}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Bobot SS"} />,
      selector: (row) => (
        <HighlightedCell
          searchTerm={filterText}
          searchIndex={row.bobot_sasaran_strategis.toLowerCase().indexOf(filterText.toLowerCase())}
        >
          {row.bobot_sasaran_strategis}
        </HighlightedCell>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <div>
          <ButtonGroup>
            {/* <UncontrolledDropdown direction="up"> */}
            <UncontrolledDropdown>
              <DropdownToggle caret></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  className={getDarkDropdown(themeContext)}
                  onClick={() => {
                    toggleDetailOpen(row);
                  }}
                >
                  Lihat Detail
                </DropdownItem>
                <DropdownItem divider />
                <Link
                  to={`${process.env.PUBLIC_URL}/capaianss/editcapaianss/${row.id}`}
                >
                  <DropdownItem className={getDarkDropdown(themeContext)}>
                    Ubah
                  </DropdownItem>
                </Link>
                <DropdownItem divider />
                <DropdownItem
                  className={getDarkDropdown(themeContext)}
                  onClick={() => toggleDeleteOpen(row)}
                >
                  Hapus
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </ButtonGroup>
          <DeleteCapaianSS
            deleteModalOpen={deleteOpen === row.id}
            toggleDeleteModal={toggleDeleteOpen}
            selectedCapaian={selectedCapaian}
            getCapaianSS={capaianSS}
            axiosInstance={axiosInstance}
          />
          <ModalDetailCapaianSS
            rincianModalOpen={detailOpen === row.id}
            toggleRincianModal={toggleDetailOpen}
            selectedCapaian={selectedCapaian}
          />
        </div>
      ),
    },
  ];

  return columns;
};

export default DaftarCapaianSSColumns;
